export const breakpoints = {
  base: '0px',
  xs: '431px',
  sm: '769px',
  md: '970px',
  lg: '1171px',
  xl: '1441px',
  '2xl': '1921px',
};
